import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TrailsService } from '../../../../../../services/trails.service';
import { RouteMapService } from '../../../../../../services/routemap.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import moment from 'moment';

@Component({
  selector: 'app-trail-add-edit',
  templateUrl: './trail-add-edit.component.html',
  styleUrls: ['./trail-add-edit.component.scss'],
  providers: [MessageService],
})
export class TrailAddEditComponent implements OnInit {
  public trail: any = {
    coverPhoto: null,
    terrainType: [],
    facilities: [],
    trailRoutes: [],
    trailTradingHours: [],
    trailsMedia: [],
  };
  public loading: boolean = false;
  public saving: boolean = false;
  public deleting: boolean = false;
  public editorConfig: AngularEditorConfig = {
    spellcheck: false,
    editable: true,
    height: 'auto',
    minHeight: '100px',
    maxHeight: '300px',
    width: 'auto',
    minWidth: '0',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: 'Nunito Sans',
    defaultFontSize: '16',
    sanitize: false,
  };
  public placeholderImage = '../../../../../../../assets/placeholder.jpg';
  //todo (dcorbett) removed require
  public conditions: any = [
    { value: '1', label: 'Very Poor' },
    { value: '2', label: 'Poor' },
    { value: '3', label: 'Un-maintained' },
    { value: '4', label: 'Good' },
    { value: '5', label: 'Excellent' },
  ];
  public status: any = [
    { value: 'Open', label: 'Open' },
    { value: 'Closed', label: 'Closed' },
    { value: 'Call to enquire', label: 'Call to enquire' },
  ];
  public dayOfWeeks: any = [
    {
      dayOfTheWeek: 0,
      openTime: '06:00:00',
      closeTime: '18:00:00',
      open: false,
    },
    {
      dayOfTheWeek: 1,
      openTime: '06:00:00',
      closeTime: '18:00:00',
      open: false,
    },
    {
      dayOfTheWeek: 2,
      openTime: '06:00:00',
      closeTime: '18:00:00',
      open: false,
    },
    {
      dayOfTheWeek: 3,
      openTime: '06:00:00',
      closeTime: '18:00:00',
      open: false,
    },
    {
      dayOfTheWeek: 4,
      openTime: '06:00:00',
      closeTime: '18:00:00',
      open: false,
    },
    {
      dayOfTheWeek: 5,
      openTime: '06:00:00',
      closeTime: '18:00:00',
      open: false,
    },
    {
      dayOfTheWeek: 6,
      openTime: '06:00:00',
      closeTime: '18:00:00',
      open: false,
    },
    {
      dayOfTheWeek: 7,
      openTime: '06:00:00',
      closeTime: '13:00:00',
      open: false,
    },
  ];
  public workingHours: any = [];
  public skillLevels: any = [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Beginner - Intermediate', label: 'Beginner - Intermediate' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Intermediate - Advanced', label: 'Intermediate - Advanced' },
    { value: 'Advanced', label: 'Advanced' },
    { value: "Pro's ONLY", label: "Pro's ONLY" },
  ];

  constructor(
    private trailsService: TrailsService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    public mapService: RouteMapService,
    public confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    this.calculateTradingTimes();

    let uniqueID = this.route.snapshot.paramMap.get('id');
    if (uniqueID) {
      this.loading = true;
      this.trailsService.getTrail(uniqueID).subscribe((trail) => {
        this.trail = trail;
        this.loading = false;
        trail.trailTradingHours.forEach((element) => {
          this.dayOfWeeks[element.dayOfTheWeek] = element;
        });

        setTimeout(() => {
          this.mapService.setMap();
          this.trail.trailRoutes.forEach((element) => {
            if (element.polyLine) {
              this.mapService.addPolyLine(element.polyLine, element.routeColor);
            }
          });
        }, 1000);
      });
    } else {
      this.trail.trailTradingHours.forEach((element) => {
        this.dayOfWeeks[element.dayOfTheWeek] = element;
      });
      setTimeout(() => {
        this.mapService.setMap();
      }, 1000);
    }
  }

  calculateTradingTimes() {
    let date = moment().startOf('day').toDate();
    this.workingHours.push({
      label: moment(date).format('HH:mm:ss'),
      value: moment(date).format('HH:mm:ss'),
    });
    for (let i = 0; i < 47; i++) {
      date.setMinutes(date.getMinutes() + 30);
      this.workingHours.push({
        label: moment(date).format('HH:mm:ss'),
        value: moment(date).format('HH:mm:ss'),
      });
    }
  }

  getDayOfWeek(day) {
    switch (day) {
      case 0:
        return 'Sunday';
        break;
      case 1:
        return 'Monday';
        break;
      case 2:
        return 'Tuesday';
        break;
      case 3:
        return 'Wednesday';
        break;
      case 4:
        return 'Thursday';
        break;
      case 5:
        return 'Friday';
        break;
      case 6:
        return 'Saturday';
        break;
      case 7:
        return 'Public Holidays';
        break;
    }
  }

  valid() {
    return true;
  }

  addRoute() {
    this.trail.trailRoutes.push({});
  }

  removeRoute(index) {
    this.confirmationService.confirm({
      header: 'Remove Route',
      message: 'Are you sure you would like to remove this route?',
      accept: () => {
        this.trail.trailRoutes.splice(index, 1);
      },
    });
  }

  saveTrail() {
    this.saving = true;
    this.trail.trailTradingHours = this.dayOfWeeks;
    if (this.trail.uniqueID) {
      this.trailsService.updateTrail(this.trail).subscribe(
        (result) => {
          this.saving = false;
          this.router.navigateByUrl('/administration/trails-management');
        },
        (error) => {
          this.saving = false;
        },
      );
    } else {
      this.trailsService.addTrail(this.trail).subscribe(
        (result) => {
          this.saving = false;
          this.router.navigateByUrl('/administration/trails-management');
        },
        (error) => {
          this.saving = false;
        },
      );
    }
  }

  updateMap() {
    this.mapService.clearMap();
    this.trail.trailRoutes.forEach((route) => {
      if (route.gpxurl && route.gpxurl.indexOf('https://') === -1) {
        this.mapService.plotGpx(route.gpxurl, route.routeColor, () => {});
      } else if (route.polyLine) {
        this.mapService.addPolyLine(route.polyLine, route.routeColor);
      }
    });
  }

  myUploader(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.trail.coverPhoto = reader.result.toString();
    };
  }

  async myImagesUploader(event) {
    if (event.target.files && event.target.files.length > 0) {
      for (var i = 0; i < event.target.files.length; i++) {
        var file = event.target.files[i];
        var data = await this.readFileAsync(file);
        this.trail.trailsMedia.push({
          mediaURL: data,
          mediaType: file.type,
        });
      }
    }
  }

  removeImage(index) {
    this.trail.trailsMedia.splice(index, 1);
  }

  readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result.toString());
      };
      reader.onerror = reject;
    });
  }

  uploadGPX(event, route) {
    let uploadFile = event.target.files[0];
    var reader = new FileReader();
    reader.readAsText(uploadFile);
    reader.onload = (file: any) => {
      this.mapService.plotGpx(
        file.target.result,
        route.routeColor,
        (distance, ascent, decent) => {
          route.distance = Math.round(distance);
          route.ascent = Math.round(ascent);
          route.decent = Math.round(decent);
        },
      );
      route.gpxurl = file.target.result;
    };
  }

  removeGPX(route) {
    route.gpxurl = null;
    route.polyLine = null;
    this.updateMap();
  }

  deleteTrail() {
    this.confirmationService.confirm({
      header: 'Delete Trail',
      message: 'Are you sure you would like to delete this trail?',
      accept: () => {
        if (this.trail.uniqueID) {
          this.deleting = true;
          this.trailsService.deleteTrail(this.trail.uniqueID).subscribe(
            (result) => {
              this.deleting = false;
              this.router.navigateByUrl('/administration/trails-management');
            },
            (error) => {
              this.deleting = false;
            },
          );
        }
      },
    });
  }
}
